import { client } from './client'

const getAllAnalystsService = async (cocap: string) => {
  const { data } = await client.get('/person/analysts', {
    headers: {
      cocap
    }
  })
  return data
}

const getAnalystNewCases = async (cocap: string, analystId: string) => {
  const { data } = await client.get(`/analyst/new?id=${analystId}`, {
    headers: {
      cocap
    }
  })
  return data
}

const getAnalystCases = async (cocap: string, analystId: string) => {
  const { data } = await client.get(`/analyst?id=${analystId}`, {
    headers: {
      cocap
    }
  })
  return data
}

const getAnalystSelectedCases = async (cocap: string) => {
  const { data } = await client.get('/analyst/selected', {
    headers: {
      cocap
    }
  })
  return data
}

const getRecoveredPendingStudyService = async (cocap: string) => {
  const { data } = await client.get('/person/recovered-pending-study', {
    headers: {
      cocap
    }
  })
  return data
}

const putCaseInfo = async (cocap: string, analystId: string, userData: any) => {
  const { data } = await client.put(`/analyst/files?id=${analystId}`, userData, {
    headers: {
      cocap
    }
  })
  return data
}

export {
  getAllAnalystsService,
  getAnalystNewCases,
  getAnalystCases,
  putCaseInfo,
  getAnalystSelectedCases,
  getRecoveredPendingStudyService
}
